import { useCallback } from 'react'
import { getElementLineEndpoints } from '@editorUtils'
import { toNumber } from 'lodash-es'
import { Vector3 } from 'three'
import { useGuidToElementIncludingRips } from '@editorHooks'

/**
 * Resolves where a support sits in the scene: its relative position interpolated
 * along the member's axis, the same way the results scene places its support
 * labels. Null for members without a line geometry (or an unparsable position).
 */
const useSupportMarkerPosition = (): ((
  elementGuid: string,
  relativePosition: string,
) => Vector3 | null) => {
  const guidToElement = useGuidToElementIncludingRips()

  return useCallback(
    (elementGuid: string, relativePosition: string) => {
      const endpoints = getElementLineEndpoints(guidToElement[elementGuid])
      if (!endpoints) return null

      const position = toNumber(relativePosition)
      if (!Number.isFinite(position)) return null

      const start = new Vector3(endpoints.start.x, endpoints.start.y, endpoints.start.z)
      const end = new Vector3(endpoints.end.x, endpoints.end.y, endpoints.end.z)

      return start.lerp(end, position)
    },
    [guidToElement],
  )
}

export default useSupportMarkerPosition
